import { memo } from 'react';
import type { AriaAttributes } from 'react';
import { clsx } from 'clsx';
import { Text } from '@library';
import styles from './PaginationButton.module.scss';

interface PaginationButtonProps extends AriaAttributes {
    page: number;
    value: number;
    onChange(value: number): void;
}

const PaginationButton = ({ page, value, onChange }: PaginationButtonProps) => {
    return (
        <div
            role="button"
            tabIndex={0}
            onClick={() => onChange(value)}
            onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => {
                if (['Enter', ' '].includes(e.key)) {
                    onChange(value);
                }
            }}
            className={clsx(styles.paginationButton, {
                [styles.selected]: page === value,
            })}
            data-test-class="paginationPageButton"
        >
            <Text caption bold={page === value} uppercase>
                {value}
            </Text>
        </div>
    );
};

export default memo(PaginationButton);
